(() => {
  if (window.__freeShippingProgressLoaded) return;
  window.__freeShippingProgressLoaded = true;

  const selector = '[data-free-shipping-progress]';

  const formatMoney = (cents, widget) => {
    const currency = widget.dataset.currencyCode || window.Shopify?.currency?.active || 'EUR';
    const withCode = widget.dataset.currencyCodeEnabled === 'true';
    const value = (Number(cents) || 0) / 100;
    const formatted = value.toLocaleString(document.documentElement.lang || undefined, {
      style: 'currency',
      currency,
    });

    return withCode && !formatted.includes(currency) ? `${formatted} ${currency}` : formatted;
  };

  const renderTemplate = (template, amount, threshold) =>
    (template || '')
      .replaceAll('[amount]', amount)
      .replaceAll('[threshold]', threshold);

  const updateWidget = (widget, totalPrice) => {
    const threshold = Number(widget.dataset.shippingThreshold) || 0;
    const bonusEnabled = widget.dataset.bonusEnabled === 'true';
    const bonusThreshold = Number(widget.dataset.bonusThreshold) || 0;
    const goal = bonusEnabled && bonusThreshold > threshold ? bonusThreshold : threshold;

    if (!threshold || !goal) return;

    const total = Math.max(Number(totalPrice) || 0, 0);
    const remaining = Math.max(threshold - total, 0);
    const progress = Math.min((total / goal) * 100, 100);
    const marker = Math.min((threshold / goal) * 100, 100);
    const message = widget.querySelector('.conversion-widget__shipping-message');
    const progressbar = widget.querySelector('[role="progressbar"]');

    widget.dataset.shippingTotal = String(total);
    widget.style.setProperty('--shipping-progress', `${progress}%`);
    widget.style.setProperty('--shipping-marker', `${marker}%`);

    if (message) {
      const amount = formatMoney(remaining, widget);
      const thresholdMoney = formatMoney(threshold, widget);
      const template =
        remaining > 0 ? widget.dataset.shippingMessageTemplate : widget.dataset.shippingSuccessTemplate;

      message.innerHTML = renderTemplate(template, amount, thresholdMoney);
    }

    if (progressbar) {
      progressbar.setAttribute('aria-valuemax', String(goal));
      progressbar.setAttribute('aria-valuenow', String(Math.min(total, goal)));
    }
  };

  const syncProductWidgetsFromHtml = (html) => {
    if (!html) return false;

    const source = new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
    if (!source) return false;

    document.querySelectorAll(selector).forEach((widget) => {
      if (widget.closest('cart-drawer')) return;
      widget.outerHTML = source.outerHTML;
    });

    return true;
  };

  const getCartDrawerSectionHtml = (cartData) =>
    cartData?.sections?.['cart-drawer'] || cartData?.sections?.CartDrawer || '';

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      window.setTimeout(() => {
        const sectionSynced = syncProductWidgetsFromHtml(getCartDrawerSectionHtml(event?.cartData));

        if (!sectionSynced && typeof event?.cartData?.total_price !== 'undefined') {
          document.querySelectorAll(selector).forEach((widget) => {
            if (widget.closest('cart-drawer')) return;
            updateWidget(widget, event.cartData.total_price);
          });
        }
      }, 0);
    });
  }
})();
